import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import { Grid, Row, Col, FormGroup, Radio, Button } from 'react-bootstrap'

import { handleErrorFetchingData } from '../../../functions/errorHandling'

import { setUser} from '../../login/reducers/manageLogin'


class ChangeEmailSettings extends Component {

  state = {
    ignore_emails: this.props.currentUser.ignore_emails,
  }

  toggleIgnoreEmails = () => {
    this.setState({ ignore_emails: !this.state.ignore_emails })
  }

  handleSave = () => {
    const { ignore_emails } = this.state
    axios({
      method: "PATCH",
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
      url: this.props.currentUser.url,
      data: { ignore_emails }
    })
    .then(response => {
      const user = {
        ...response.data,
        pk: response.data.id
      }

      this.props.setUser(user)

      return swal({
        title: "Success",
        text: "Your email settings have been updated",
        icon: "success",
        button: "Continue",
      })
    })
    .catch(error => {
      const message = 'There was an error updating your email settings'
      handleErrorFetchingData(error, message)
    })
  }

  render() {
    const { ignore_emails } = this.state
    return (
      <div id="ChangePasswordContainer">
        <Grid>
          <Row>
            <Col xsHidden md={4}></Col>
            <Col xs={12} md={4}>
              <FormGroup>
                <Radio
                  onChange={this.toggleIgnoreEmails}
                  checked={ignore_emails === false}
                >
                  Send me email reminders
                </Radio>
                <Radio
                  onChange={this.toggleIgnoreEmails}
                  checked={ignore_emails === true}
                >
                  Please do not email me
                </Radio>
              </FormGroup>
              <br/>
              <div id="login-button">
              <Button onClick={this.handleSave}>
                Save
              </Button>
              </div>
            </Col>
            <Col xsHidden md={4}></Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user,
  }
}

export default connect(mapStateToProps, { setUser })(ChangeEmailSettings)



// WEBPACK FOOTER //
// ./src/routes/user-settings/components/ChangeEmailSettings.js